import { ToggleGroup } from '@policygenius/mortar';
import React from 'react';
import { createUseStyles } from 'react-jss';

import getErrorMessage from 'forms/getErrorMessage';

import { ToggleFieldProps } from './types';
import { fromString, toString } from './utils';
import styles from '../styles';
import { InputChoice } from '../types';
import useField from '../useField';

const useStyles = createUseStyles(styles);

const DEFAULT_CHOICES: Array<InputChoice<any, string>> = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

function ToggleField<Value = boolean>({
  name,
  onChange,
  choices = DEFAULT_CHOICES,
  config,
  ...props
}: ToggleFieldProps<Value>) {
  const classes = useStyles();
  const { input, meta } = useField<Value>(name, config);

  const _onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const value = fromString(event.target.value) as Value;

    onChange?.(value);

    input.onChange(value);
  };

  const options = React.useMemo<NonNullable<ToggleGroup.Props['options']>>(
    () =>
      choices.map((choice) => ({
        label: choice.label,
        value: toString(choice.value),
      })),
    [choices]
  );

  return (
    <div className={classes.fieldContainer}>
      <ToggleGroup
        {...input}
        {...props}
        defaultValue={toString(meta.initial)}
        errorMessage={getErrorMessage(meta)}
        onChange={_onChange}
        options={options}
        showGroupLabel
      />
    </div>
  );
}

export default ToggleField;
